import { defineMessage } from '../../../../../services/localization';

export const messages = {
    title: defineMessage('get_more_financial_cont_ll_our_toptier_features'),
    chooseOrganisation: defineMessage('choose_organisation'),
    moreThan: defineMessage('more_than_approvalmax_c_bust_financial_controls'),
    upgrade: defineMessage('upgrade_your_subscription'),
    tryFree: defineMessage('try_all_features_for_days'),
    cancelAnytime: defineMessage('no_additional_charges_cancel_anytime'),
    notifyAdmins: defineMessage('notify_admins_about_free_allfeature_trial'),
    notifyAdminsDescription: defineMessage('all_admins_of_the_selec_te_the_allfeature_trial'),
};
